"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f353 = void 0;
exports.f353 = {
    "šäyxil": [
        195
    ],
    "š-šāmiyye": [
        368
    ],
    "šwan-är": [
        7213,
        7214,
        7215
    ]
};
